import type { FC, ReactElement, ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

import './data-point.scss'

const DataPoints: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => (
  <div className={twMerge('data-points', className)}>{children}</div>
)

export const DataPoint: FC<{
  header?: string | ReactElement
  value?: string | ReactElement
  values?: string[] | ReactElement[]
  className?: string
  headerClassName?: string
}> = ({ header = '', value = '', values = [], className, headerClassName }) => (
  <div className={twMerge('data-point', className)}>
    {header && <h4 className={headerClassName}>{header}</h4>}

    {[value, ...values].map((value, idx) => (
      <div className="data-point__value" key={idx}>
        {value}
      </div>
    ))}
  </div>
)

export default DataPoints
